import DicomLogDetail from "./DicomLogDetail"

export default DicomLogDetail